import React, { ReactElement } from "react";
import { GetStaticProps } from "next";
import SeveralBrandsWrapper from "@components/layouts/severalBrandsWrapper";
import FirstSection from "@components/severalbrands/keyConsiderationsPdfPage/firstSection";
import { DomainInfo } from "@components/severalbrands/utils/services";
import initialCall from "@components/severalbrands/utils/initialCall";
import MetaTags from "@components/severalbrands/metaTags";
import {
    getKeyWordsForMetaTags,
    getMetaTitleDescriptionForPage,
} from "@components/severalbrands/utils";

export default function SeveralBrandsHome({
    domain,
}: {
    domain: DomainInfo;
}): ReactElement {
    const metaTags = getMetaTitleDescriptionForPage(
        domain,
        "keyConsiderations",
    );
    return (
        <SeveralBrandsWrapper domainInfo={domain}>
            <MetaTags
                title={
                    metaTags?.title ??
                    "Claim Your Free Guide | SeveralBrands.com"
                }
                description={
                    metaTags?.description ??
                    "Several Brands LLC is a Performance Marketer Firm. We generate leads, calls and live transfers for local businesses. Furthermore, we promote various products from several affiliate networks."
                }
                keyWords={getKeyWordsForMetaTags(domain)}
            />
            <FirstSection />
        </SeveralBrandsWrapper>
    );
}

//@ts-ignore
export const getStaticProps: GetStaticProps = async () => {
    return await initialCall("keyConsiderations");
};
